import { createRootRoute } from "@tanstack/react-router";
import { AccentBar } from "@engagexp/legendary-ui-primitives";
import { ThemeProvider } from "~/app/components/ThemeProvider";
import { BrandProvider } from "~/app/components/BrandProvider";
import { GamificationProvider } from "~/app/components/GamificationProvider";
import { OpeningSequence } from "~/app/components/OpeningSequence";
import { Layout } from "~/app/components/Layout";

export const Route = createRootRoute({
  component: RootComponent,
});

function RootComponent() {
  return (
    <ThemeProvider>
      <BrandProvider>
        <GamificationProvider>
          <OpeningSequence>
            <AccentBar />
            <Layout />
          </OpeningSequence>
        </GamificationProvider>
      </BrandProvider>
    </ThemeProvider>
  );
}
